export default __webpack_public_path__ + "assets/icons/info.07f95872.svg";